/**
 * First-party Cross Domain Cookies
 */
import Cookies from "js-cookie";
import { isObject } from "lodash-es";

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const tld = location.hostname.includes(".test") ? "test" : "org";
const cookie = Cookies.withAttributes({ domain: `.coastal1.${tld}`, expires: 365, secure: true, sameSite: "strict" }).withConverter({
  read: function (value, name) {
    if (isJson(value)) {
      return JSON.parse(value);
    }

    return Cookies.converter.read(value, name);
  },
  write: function (value, name) {
    if (isObject(value)) {
      return JSON.stringify(value);
    }

    return Cookies.converter.write(value, name);
  },
});

export default cookie;
